module.exports = __webpack_public_path__ + "static/media/Validation5.73de2f88.png";